/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelper.js').customRequest;
  var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Pobierz style
   * @method
   * @name Api#getStyles
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.id_warstwy - ID warstwy
   * @param {boolean} parameters.domyslny - Czy zwrócić tylko styl domyślny
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getStyles = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/styles',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined) {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    parameterPath = parameterPath.replace(
      '{id_warstwy}',
      parameters['id_warstwy']
    );

    parameterPath = parameterPath.replace('{domyslny}', parameters['domyslny']);

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Nadaj styl
   * @method
   * @name Api#postStyles
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {} parameters.body -
   */
  Api.prototype.postStyles = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/styles',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuń styl
   * @method
   * @name Api#deleteStylesById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - Hash ID stylu
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteStylesById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/styles/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz styl
   * @method
   * @name Api#getStylesById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID stylu
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getStylesById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/styles/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
